export default "__VITE_ASSET__DWJHdaZB__"